export default "__VITE_ASSET__9c76de7a__"